// src/hooks/useLabPermissions.js
import { useMemo } from 'react';
import { useAuth } from '../components/system/AppGate';

export function useLabPermissions() {
  const {
    profile,
    loading,
    permissions = [],
    hasPermission = () => false,
  } = useAuth();

  return useMemo(() => {
    if (loading || !profile) {
      return {
        loading: true,
        role: null,
        isAdmin: false,
        isLabManager: false,
        isTechnician: false,
        isReception: false,
        isAdministrativeAssistant: false,
        permissions: [],
        hasPermission,
      };
    }

    const role = profile.role;

    return {
      loading: false,
      role,
      isAdmin: role === 'admin',
      // El administrador es un superrol operativo: hereda las capacidades
      // del jefe de laboratorio además de conservar las propias.
      isLabManager: role === 'lab_manager' || role === 'admin',
      isTechnician: role === 'technician',
      isReception: role === 'reception',
      isAdministrativeAssistant: role === 'administrative_assistant',
      permissions,
      hasPermission,
    };
  }, [profile, loading, permissions, hasPermission]);
}
